function Loading() {
  return (
    <div className="d-flex justify-content-center align-items-center my-5 h2">
      Loading...
    </div>
  );
}

export default Loading;